import { render, staticRenderFns } from "./FinalInfo.vue?vue&type=template&id=5613a445&scoped=true&"
import script from "./FinalInfo.vue?vue&type=script&lang=js&"
export * from "./FinalInfo.vue?vue&type=script&lang=js&"
import style0 from "./FinalInfo.vue?vue&type=style&index=0&id=5613a445&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5613a445",
  null
  
)

export default component.exports